import * as Types from "../action.types"
import * as Models from "../../models/index"
import * as Services from "../../service/index"
import* as Selectors from "../../selectors/pwd.validate.selector";

export const validateUserPassword = (isExpired = false) => (d: Function, gs: () => Models.StoreState) => {
    let isNeededValidation = Selectors.isNeededValidation(gs());
 
    if(isNeededValidation) {
        d({
            type: Types.PWD_EXPIRED_PENDING
        });
        Services.Recovery.validateUserPassword({
            username: isExpired ? gs().login.userName : gs().pwdRecovery.username,
            password: gs().pwdSecurity.password,
            confirmPassword: gs().pwdSecurity.confirmPassword
        }).then(response => {
            d({
                type: Types.PWD_UPDATE_VALIDATION_USER_PASSWORD,
                payload: response as Types.PWD_UPDATE_VALIDATION_USER_PASSWORD_PAYLOAD
            })
        })
    }    
}

export const validateOldPassword = () => (d: Function, gs: () => Models.StoreState) => {
    
    if(gs().pwdValidate.isNeededValidation) {
        d({
            type: Types.PWD_EXPIRED_PENDING
        });
        Services.Recovery.validateOldPassword({
            username: gs().login.userName,
            oldPassword: gs().pwdSecurity.oldPassword
        }).then( response => {
            d({
                type: Types.PWD_UPDATE_VALIDATION_OLD_PASSWORD,
                payload: response as Models.ValidateUserPassword_Response_Client
            })
            
            if(response.isPassed) {
                d({
                    type: Types.PWD_UPDATE_IS_NEEDED_VALIDATION,
                    payload: false
                })
            }
        })
    }    
}